module.exports = __webpack_public_path__ + "static/fortis-logo-5d2b676e44d7318d5eedef4677d85e5e.png";